<template>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <div
      class="card-panel-main col-lg-9 mb-5"
      style="position: absolute; right: 28vw; width: 51vw; height: auto;"
    >
      <div class="card card-body card-panel-box border-0 p-5" style="margin: 1vw .9vw;">
        
        <!-- هدر صفحه -->
        <div class="d-flex justify-content-between">
          <h3>تدوین استراتژی / SO (تهاجمی)</h3>
          <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
        </div>
        <hr class="mb-3" />

        <!-- بخش اول: جدول قوت‌ها و فرصت‌ها -->
        <div class="card p-4 mb-4">
          <h4>جدول قوت‌ها و فرصت‌ها</h4>
          <table class="table table-bordered text-center mt-3 forsat">
            <thead>
              <tr>
                <th>قوت‌ها</th>
                <th>فرصت‌ها</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <!-- ستون قوت‌ها -->
                <td>
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr v-for="(strength, index) in strengths" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ strength }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <!-- ستون فرصت‌ها -->
                <td>
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr v-for="(opportunity, index) in opportunities" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ opportunity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- بخش دوم: فرم افزودن استراتژی -->
        <div class="card p-4 mb-4">
          <h4>افزودن استراتژی SO</h4>
          <form @submit.prevent="addStrategy" class="d-flex gap-2 mt-3">
            <input
              type="text"
              v-model="newStrategy"
              class="form-control"
              placeholder="عنوان استراتژی SO را وارد نمایید"
            />
            <button style="    font-size: 1vw;
    padding: 0.9vw
12.294px
;" type="submit" class="btn btn-primary btn-submit-1">افزودن</button>
          </form>
        </div>

        <!-- بخش سوم: جدول استراتژی‌ها -->
        <div class="card p-4">
          <h4 style="border-bottom: solid 1px #605d5d;
    padding: 1vw;
    margin-bottom: 1vw;">لیست استراتژی‌ها</h4>
          <table class="table table-striped text-center mt-3" v-if="strategies.length">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>عنوان استراتژی</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(strategy, index) in strategies" :key="index">
                <td>{{ index + 1 }}</td>
                <td v-if="!strategy.editing">{{ strategy.title }}</td>
                <td v-else>
                  <input v-model="strategy.title" class="form-control" />
                </td>
                <td>
                  <button
                    v-if="!strategy.editing"
                    @click="editStrategy(strategy)"
                    class="btn btn-warning btn-sm"
                  >
                    ویرایش
                  </button>
                  <button
                    v-if="strategy.editing"
                    @click="saveStrategy(strategy)"
                    class="btn btn-success btn-sm"
                  >
                    ذخیره
                  </button>
                  <button
                    @click="deleteStrategy(index)"
                    class="btn btn-danger btn-sm ms-2"
                  >
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="text-center text-muted">هیچ استراتژی ثبت نشده است</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";

export default {
  name: "HomeView",
  components: { Sidebar },
  data() {
    return {
      strengths: [
        "منابع انسانی متخصص",
        "سیستم مدیریتی کارآمد",
        "دسترسی به فناوری‌های نوین",
        "زیرساخت مناسب",
        "روابط عمومی قوی",
        "توان مالی بالا",
        "تیم تحقیق و توسعه فعال",
        "فرهنگ سازمانی مثبت",
        "برند معتبر",
        
      ],
      opportunities: [
        "رشد تقاضای داخلی",
        "ورود به بازارهای صادراتی",
        "سرمایه‌گذاری دولتی",
        "همکاری‌های بین‌المللی",
        "توسعه فناوری‌های نو",
        "افزایش آگاهی مشتریان",
        "سیاست‌های حمایتی دولت",
        "رشد جمعیت جوان",
      ],
      strategies: [],
      newStrategy: "",
    };
  },
  methods: {
    addStrategy() {
      if (!this.newStrategy.trim()) return;
      this.strategies.push({ title: this.newStrategy, editing: false });
      this.newStrategy = "";
    },
    deleteStrategy(index) {
      this.strategies.splice(index, 1);
    },
    editStrategy(strategy) {
      strategy.editing = true;
    },
    saveStrategy(strategy) {
      strategy.editing = false;
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-size: 1.3vw !important;
}
h4 {
  font-size: 1.2rem;
  font-weight: bold;
}
.forsat td{
vertical-align: top;
}

.btn.btn-sm{
    font-size: 0.7vw !important;

}
</style>
